import { render, staticRenderFns } from "./Well.vue?vue&type=template&id=77a9c4f1&scoped=true&"
import script from "./Well.vue?vue&type=script&lang=ts&"
export * from "./Well.vue?vue&type=script&lang=ts&"
import style0 from "./Well.vue?vue&type=style&index=0&id=77a9c4f1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77a9c4f1",
  null
  
)

export default component.exports